import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { Product } from "@shared/types";
import { api } from "@/lib/api";
import { useWishlist } from "@/lib/wishlist";
import { StorefrontLayout } from "@/components/StorefrontLayout";
import { ProductCard } from "@/components/ProductCard";

export function Wishlist() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState<Product[] | null>(null);

  useEffect(() => {
    api.products
      .list()
      .then((all) => setProducts(all.filter((p) => ids.includes(p.id))))
      .catch(() => setProducts([]));
  }, [ids]);

  return (
    <StorefrontLayout>
      <div className="px-5 pb-8 pt-6">
        <h1 className="mb-6 font-display text-2xl font-medium text-ink">Wishlist</h1>

        {products === null ? (
          <div className="grid grid-cols-2 gap-x-4 gap-y-6">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="aspect-[164/277] animate-pulse rounded-xl bg-stone-100" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="flex flex-col items-center gap-4 py-20 text-center">
            <p className="text-sm text-stone-500">Nothing saved yet — tap the heart on any item to add it here.</p>
            <Link to="/" className="text-sm font-semibold text-ink underline">
              Continue shopping
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-x-4 gap-y-6">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </StorefrontLayout>
  );
}
